import styled from "styled-components";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";

const StyledSideBar = styled.div`
	background-color: white;
	width: 215px;
    box-sizing: border-box;
	min-height: 275px;
	height: 100%;
	padding: 20px;
`;

const Title = styled.span`
	display: block;
	font-size: 14px;
	font-weight: 600;
	padding-bottom: 15px;
	color: ${(props) => props.theme.color.dark};
`;

const ItemLink = styled(Link)`
	display: block;
	font-size: 12px;
	font-weight: 600;
	color: ${(props) => props.theme.color.gray};
	padding-left: 11px;
	padding-top: 10px;
	padding-bottom: 10px;

	text-decoration: none;

	&:focus, &:visited, &:link, &:active {
		text-decoration: none;
	}
	&:hover {
		text-decoration: none;
		background-color: ${(props) => props.theme.color.secondaryhover};
		border-radius: 5px;
	}
    :active {
        box-shadow: 0 0 1px ${(props) => props.theme.color.primaryhover};
    }
`;

const SelectedItemLink = styled(Link)`
	display: block;
	font-size: 12px;
	font-weight: 600;
	color: ${(props) => props.theme.color.primaryblue};
	padding-left: 6px;
	padding-top: 10px;
	padding-bottom: 10px;
	border-left: solid 5px ${(props) => props.theme.color.secondaryhover};

	text-decoration: none;

	&:focus, &:hover, &:visited, &:link, &:active {
		text-decoration: none;
	}
	&:hover {
		text-decoration: none;
		background-color: ${(props) => props.theme.color.secondaryhover};
		border-radius: 5px;
	}
    :active {
        box-shadow: 0 0 1px ${(props) => props.theme.color.primaryhover};
    }
`;

function SideBar({title, items, defaultPath, selectedSubPagePath, ...props}) {

	const handleSelectItem = (itemText) => {
	}
  
    return (
        <StyledSideBar>
			<Title>{title}</Title>
			{items.map((item, index) => {
				return selectedSubPagePath !== item.path ? 
				<ItemLink to={defaultPath + item.path} key={index} onClick={() => handleSelectItem(item.text)}>{item.text}</ItemLink> : 
				<SelectedItemLink to={defaultPath + item.path} key={index} onClick={() => handleSelectItem(item.text)}>{item.text}</SelectedItemLink>;
			})}
		</StyledSideBar>
    )
}

SideBar.propTypes = {
    setPageTitle: PropTypes.func,
};

export default SideBar;